import { FacetRenderItem } from '@features/facetingEngine/types';
import { Box, Button, Flex } from '@radix-ui/themes';
import { useState } from 'react';
import { Trans } from 'react-i18next';
import { INITIAL_VISIBLE_COUNT } from '../constants';
import { useBooleanFacetItems } from '../hooks/useBooleanFacetItems';
import { FacetFlow } from './FacetFlow';

interface BooleanFilterProps {
    facetKey: string;
}

export const BooleanFilter = ({ facetKey }: BooleanFilterProps) => {
    const [showMore, setShowMore] = useState(false);

    const {
        config,
        sortedPresets,
        sortedExtras,
        checkIsActive,
        handleToggle,
        getCount,
        handleGetLabel,
        handleGetKey,
    } = useBooleanFacetItems(facetKey);

    if (!config) return null;

    const maxVisible = config.maxVisibleValues ?? INITIAL_VISIBLE_COUNT;

    const visibleExtras =
        showMore || sortedPresets.length > 1
            ? []
            : sortedExtras.slice(0, maxVisible);

    const remainingExtras = showMore
        ? sortedExtras
        : sortedExtras.slice(maxVisible);

    return (
        <Flex direction={'column'} gap={'2'}>
            <FacetFlow<FacetRenderItem>
                facets={[...sortedPresets, ...visibleExtras]}
                isActive={checkIsActive}
                onSelect={handleToggle}
                getLabel={handleGetLabel}
                getKey={handleGetKey}
                getCounts={getCount}
            />

            {sortedExtras.length > visibleExtras.length && (
                <Flex direction={'column'} gap={'2'}>
                    {showMore && (
                        <FacetFlow<FacetRenderItem>
                            facets={remainingExtras}
                            isActive={checkIsActive}
                            onSelect={handleToggle}
                            getLabel={handleGetLabel}
                            getKey={handleGetKey}
                            getCounts={getCount}
                        />
                    )}

                    <Box>
                        <Button
                            variant='soft'
                            size='1'
                            color='gray'
                            onClick={() => setShowMore(!showMore)}
                            style={{ background: 'none', cursor: 'pointer' }}
                        >
                            <Trans
                                i18nKey={`facetingPanel:${showMore ? 'showLess' : 'showMore'}`}
                                values={{
                                    itemCount:
                                        sortedExtras.length -
                                        visibleExtras.length,
                                }}
                            />
                        </Button>
                    </Box>
                </Flex>
            )}
        </Flex>
    );
};
